/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import 'expose-loader?jQuery!jquery' // eslint-disable-line
import 'expose-loader?$!jquery' // eslint-disable-line
import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// for vue-tables2 daterangepicker
import $ from 'jquery';
//import moment from 'moment';
import moment from 'moment-timezone';
moment.tz.setDefault('Etc/UTC');
window.moment = require('moment');

import 'daterangepicker/daterangepicker.js';
import 'daterangepicker/daterangepicker.css';
import VueMomentJS from "vue-momentjs";
Vue.use(VueMomentJS, moment);


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

axios.interceptors.request.use(
    config => {
        if (window.sessionStorage.getItem('Ella-Auth-Token')) {
            config.headers.common['Ella-Auth-Token'] = window.sessionStorage.getItem('Ella-Auth-Token')
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            throw new Error('INVALID_USER')
        } else if (error.response.status === 400 && error.response.data != null) {
            if (error.response.data === "Bad Credentials token") {
                router.push('/pages/login')
            } else {
                throw new Error(error.response.data)
            }
        }
        return Promise.reject(error);
    }
)

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import { messages as enOriginalMessages } from 'vee-validate/dist/locale/en'
import { messages as koOriginalMessages } from 'vee-validate/dist/locale/ko'
import attributesKo from './plugins/attributesKo.json'
import attributesEn from './plugins/attributesEn.json'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
    i18nRootKey: 'validations', // customize the root path for validation messages.
    i18n,
    dictionary: {
        en: {
            messages: {...enOriginalMessages },
            attributes: attributesEn
        },
        ko: {
            messages: {...koOriginalMessages },
            attributes: attributesKo
        },
    },
});

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// vue-tables-2
import { ServerTable, Event } from 'vue-tables-2'
Vue.use(ServerTable, {
    debounce: 250,
    skin: 'table',
}, true, 'bootstrap4', 'default')
Vue.use(Event);

//bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

//v-mask
import VueMask from 'v-mask'
Vue.use(VueMask)

// sanitize-html
import sanitizeHTML from "sanitize-html"
Vue.prototype.$sanitize = sanitizeHTML


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')